export default function SessionExpired() {
  return (
    <>
      <p>
        The session is expired. Please re-open the app from the Shopify admin.
      </p>
    </>
  );
}
